import React from "react";
import "../../scss/dashboard/deletemodal.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
function ContinueModal({
  toggle,
  handleClose,
  handleContinue,
  confirmationText,
  headerText,
  continueButton,
  cancelButton,
}) {
  return (
    <Modal
      isOpen={toggle}
      style={{ paddingTop: "15vw", paddingRight: "0px !important" }}
    >
      <ModalBody
        style={{
          margin: "0px auto",

          width: "500px",
          height: "200px",
        }}
      >
        <div
          style={{
            display: "grid",
            height: "100%",
            gridTemplateRows: "18% 52% 30%",
          }}
          className="ModalGrid"
        >
          <div className="ModalGridHeader">
            <span>{headerText}</span>
            <div onClick={handleClose} style={{ cursor: "pointer" }}>
              <span>X</span>
            </div>
          </div>
          <div>
            <p>{confirmationText}</p>
          </div>
          <div className="ModalGridButtons">
            <div onClick={handleClose} className="ModalGridButtons__one">
              <span>{cancelButton || "Cancelar"}</span>
            </div>
            <div
              onClick={handleContinue}
              className={`ModalGridButtons__two buttonColor--${continueButton}`}
            >
              <span>{continueButton}</span>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ContinueModal;
